import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../styles/ViewCV.css';
import Navbar from '../components/Navbar';
import 'bootstrap-icons/font/bootstrap-icons.css';

const ViewCV = () => {
  const [cvUrl, setCvUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const navigate = useNavigate();

  const [activeSection, setActiveSection] = useState("view-cv");

  useEffect(() => {
    fetchCV();
  }, []);

  const fetchCV = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/users/view-cv`,
        {
          headers: { Authorization: token },
        }
      );
      setCvUrl(response.data.cvUrl);
    } catch (error) {
      console.error('Error al obtener el CV:', error);
      setError('No se pudo obtener el CV');
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadCV = () => {
    if (cvUrl) {
      window.open(cvUrl, '_blank');
    }
  };

  const handleDeleteCV = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/api/users/delete-cv`,
        {
          headers: { Authorization: token },
        }
      );
      setCvUrl(null);
      setShowConfirmDialog(false);
      // Opcional: mostrar mensaje de éxito
    } catch (error) {
      console.error('Error al borrar el CV:', error);
      setError('No se pudo borrar el CV');
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  const ConfirmDialog = () => (
    <div className="confirm-dialog-overlay">
      <div className="confirm-dialog">
        <h4>¿Estás seguro?</h4>
        <p>Esta acción eliminará permanentemente tu CV del sistema.</p>
        <div className="confirm-dialog-buttons">
          <button
            className="btn btn-secondary"
            onClick={() => setShowConfirmDialog(false)}
          >
            Cancelar
          </button>
          <button
            className="btn btn-danger"
            onClick={handleDeleteCV}
          >
            Eliminar
          </button>
        </div>
      </div>
    </div>
  );

  if (loading) {
    return (
      <>
        <Navbar />
        <div className="dashboard-layout">
          <div className="dashboard-sidebar">
            <div className="sidebar-header"><h3>Ver CV</h3></div>
          </div>
          <div className="dashboard-main">
            <div className="cv-viewer-container" style={{ padding: 0, maxWidth: '100%' }}>
              <div className="loading-screen">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Cargando...</span>
                </div>
                <p>Cargando información del CV...</p>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className="dashboard-layout">
        {/* Sidebar */}
        <div className="dashboard-sidebar">
          <div className="sidebar-header">
            <h3>Ver CV</h3>
          </div>
          <div className="sidebar-menu">
            <button
              className={`menu-item ${activeSection === "view-cv" ? "active" : ""}`}
              onClick={() => setActiveSection("view-cv")}
            >
              <i className="bi bi-file-earmark-pdf"></i> Ver CV
            </button>
            <button
              className="menu-item return-dashboard"
              onClick={() => navigate("/dashboard")}
            >
              <i className="bi bi-arrow-left-circle"></i> Volver al Dashboard
            </button>
          </div>
        </div>

        {/* Main Content */}
        <div className="dashboard-main">
          <div className="cv-viewer-container" style={{ padding: 0, maxWidth: '100%' }}>
            {showConfirmDialog && <ConfirmDialog />}

            <div className="cv-content">
              {error ? (
                <div className="message-container error-container">
                  <i className="bi bi-exclamation-circle-fill"></i>
                  <h3>Error al obtener el CV</h3>
                  <p>{error}</p>
                  <button onClick={() => navigate('/dashboard')} className="btn btn-primary">
                    Volver al Dashboard
                  </button>
                </div>
              ) : cvUrl ? (
                <div className="cv-card">
                  <div className="cv-info">
                    <i className="bi bi-file-earmark-pdf-fill document-icon"></i>
                    <h3>Tu CV está listo para descargar</h3>
                    <p>Haz clic en el botón para ver o descargar tu CV en formato PDF</p>
                    <div className="cv-actions">
                      <button onClick={handleDownloadCV} className="btn btn-primary download-btn">
                        <i className="bi bi-download"></i> Ver/Descargar CV
                      </button>
                      <button
                        onClick={() => setShowConfirmDialog(true)}
                        className="btn btn-danger delete-btn"
                      >
                        <i className="bi bi-trash"></i> Eliminar CV
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="message-container no-cv-container">
                  <i className="bi bi-file-earmark-x-fill"></i>
                  <h3>No se encontró ningún CV</h3>
                  <p>Por favor, sube tu CV desde el Dashboard</p>
                  <button onClick={() => navigate('/dashboard')} className="btn btn-primary">
                    Ir al Dashboard
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewCV; 